function makeCreatePlayer ({ Howl }) {
  return function createPlayer (settings) {
    const player = new Howl(settings);

    const play = player.play.bind(player);
    let lastPlay;

    player.play = function (...args) {
      if (lastPlay) {
        this.stop(lastPlay);
      }
      lastPlay = play(...args);
      return lastPlay;
    };

    return player;
  };
}

export { makeCreatePlayer };

// Commit trace: 2026-01-27T23:23:36 - docs: clarify parameter types in makeCreatePlayer.js
